import React from 'react';
import PropTypes from 'prop-types';
import { compose, formatDate } from '../../../../services/utilityFunctions';
import translate from '../../../../commonComponents/translate';
import UserProp from '../../../../commonComponents/propTypes/userProp';
import InfoIcon from '../../../../commonComponents/icons/InfoIcon';

const LevelSection = props => {
  const { label, icon, value, date, wrapperClass, tooltip } = props;
  return (
    <div className={`forecast-card-container ${wrapperClass}`}>
      <div className="forecast-card">
        <div className="forecast-info-container">
          <div className="forecast-info">
            <h6 className="forecast-level">{label}</h6>
            <div className="forecast-icon">
              <img src={icon || ''} alt="" />
            </div>
            <span className="forecast-value">{value}</span>
          </div>
          {tooltip && (
            <div className="info">
              <InfoIcon width={20} height={20} color="#fff" tooltip={tooltip} />
            </div>
          )}
        </div>
        {date ? <h6 className="forecast-date">{`(${date})`}</h6> : null}
      </div>
    </div>
  );
};

LevelSection.propTypes = {
  label: PropTypes.string,
  date: PropTypes.string,
  icon: PropTypes.string,
  value: PropTypes.string,
  wrapperClass: PropTypes.string,
  tooltip: PropTypes.string,
};

LevelSection.defaultProps = {
  label: '',
  date: '',
  icon: null,
  value: '',
  wrapperClass: '',
  tooltip: '',
};

const UserCard = ({ t, directSellingActive, user }) => {
  const { skillLevel, type, forecast, skillMaxLevel, maxLevel } = user;

  const { icon, name } = skillLevel || {};
  const { skillLevel: skillForecast, date, level } = forecast || {};
  const { icon: maxLevelIcon, name: maxLevelName } = skillMaxLevel || {};

  const { icon: iconForecast, name: nameForecast } = skillForecast || {};

  const shouldSeeForecast = type === 'collaborator' && directSellingActive;

  // Forecast
  const forecastDate = date
    ? formatDate(date, 'DD MMM YYYY')
    : `(${t('profile.sidePanel.level.noForecastDate')})`;

  // if level === 0 and not exist skillForecast show (No level)
  const forecastLevelName =
    level === null && !skillForecast
      ? t('connect.teams.structure.no_level')
      : nameForecast;

  const forecastDateText = `${t(
    'profile.sidePanel.level.forecastDate',
  )}: ${forecastDate}`;

  // if empty not show
  const emptyForecast = !date && !skillForecast && level < 0;

  const mLevelName = maxLevelName || forecastLevelName;
  const mLevelIcon = maxLevelIcon || iconForecast;

  return (
    <div className="level-card" style={{ position: 'relative' }}>
      <div className="level-info-container" style={{ paddingRight: 35 }}>
        <div className="level-icon">
          <div className="level-icon-wrapper">
            <img src={mLevelIcon || ''} alt="" />
          </div>
        </div>
        <div className="level-info">
          <p className="label-level">{`${t(
            'report.laborigin.summary.highest_level',
          )}:`}</p>
          <h2 className="level-user">
            {mLevelName || t('connect.teams.structure.no_level')}
          </h2>
        </div>
        <div
          className="info-level"
          data-toggle="m-popover"
          data-content={t('report.laborigin.tooltip.highestLevel')}
        >
          <InfoIcon width={20} height={20} color="#fff" />
        </div>
      </div>
      {shouldSeeForecast && !emptyForecast && (
        <LevelSection
          label={`${t('report.laborigin.summary.forecastLevel')}:`}
          value={forecastLevelName}
          icon={iconForecast}
          date={forecastDateText}
          wrapperClass="forecastLevelWrapper"
          tooltip={t('report.laborigin.tooltip.forecastLevel')}
        />
      )}
      {name ? (
        <LevelSection
          label={`${t('report.laborigin.summary.level')}:`}
          value={name}
          icon={icon}
          wrapperClass="highestLevelWrapper"
          tooltip={t('report.laborigin.tooltip.yourLevel')}
        />
      ) : null}
    </div>
  );
};

UserCard.propTypes = {
  t: PropTypes.func.isRequired,
  directSellingActive: PropTypes.bool.isRequired,
  user: PropTypes.shape(UserProp.propType).isRequired,
};

export default compose(translate)(UserCard);
